<template>
  <div class="row">
    <v-navigation-drawer  class="text-center" v-model="drawer" right fixed floating style="z-index:99">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">Ações em Lote</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
    </v-navigation-drawer>
    <div class="text-left col-xs-12 col-md-12 col-lg-7 col-xl-7" v-if="!disabledRegisterRows">
      <ed-button
        :label="getConfig.registerName"
        color="primary"
        class="mr-1"
        :iconLeft="getConfig.registerIcon"
        @click="$emit('register')"
      />
    </div>
    <div
      :class="disabledRegisterRows ? 'col-xs-12 col-md-12 col-lg-12 col-xl-12 text-right pt-0 mt-0' : 'col-xs-12 col-md-12 col-lg-5 col-xl-5 text-right pt-0 mt-0'"
      v-if="!disabledSearchRows"
    >
      <ed-input-text
        v-model="busca.search"

        single-line
        hide-details
        @keyup.enter="onBusca"
        style="margin-top:0 !important;padding-top:0 !important"
        :label="getConfig.searchPlaceholder"
      >
        <div slot="append">
          <ed-button
            :iconLeft="$utilidade.getIcone('buscar')"
            color="secondary"
            title="Clique ou pressione ENTER para realizar a busca"
            onlyIcon
            x-small
            fab
            text
            @click="onBusca"
          />
          <ed-button
            :iconLeft="$utilidade.getIcone('filtrar')"
            color="secondary"
            title="Exibir filtro de busca"
            onlyIcon
            x-small
            fab
            text
            @click="onBusca"
          />
        </div>
      </ed-input-text>
    </div>

    <div class="text-left col-12">
      <v-data-table
        class="elevation-1 ed-table mb-4"
        v-model="selected"
        :headers="tableHeaders"
        :options.sync="options"
        :items="tableRows"
        :loading="loading"
        :show-select="!disabledSelectedRows"
        hide-default-footer
        dense
        loading-text="Carregando..."
        :no-data-text="config.noDataFound"
      >
        <!--ACOES-->
        <template v-slot:item.acoes="{ item }">
          <div class="text-center ed-table-acoes">
            <ed-button
              v-if="!disabledEditRows"
              :iconLeft="$utilidade.getIcone('editar')"
              color="primary"
              title="Editar Registro"
              icon
              onlyIcon
              @click="$emit('edit',item._item)"
            />

            <template v-for="(button,indexButton) in item.buttons">
              <ed-button
                v-if="item.buttons && item.buttons"
                :key="indexButton"
                :iconLeft="button.icone"
                :color="button.color"
                :title="button.title"
                icon
                onlyIcon
                @click="button.click(item._item)"
              />
            </template>

            <ed-button
              v-if="!disabledDeleteRows"
              :iconLeft="$utilidade.getIcone('deletar')"
              color="error"
              title="Deletar"
              icon
              onlyIcon
              @click="$emit('delete',[item._item.id])"
            />
          </div>
        </template>

        <!--
            <template v-for="(header,indexHeader) in headers" v-slot:[`item.${header.value}`]="{ item }">
              <span :class="(item._item.ativo == 0 ? 'ed-inativo' : '')" :title="(item._item.ativo == 0 ? 'Registro inativo' : '')">
                {{item[header.value]}}
              </span>
            </template>
        -->
        <template v-for="(header,indexHeader) in headers" v-slot:[`item.${header.value}`]="{ item }">
          <span
            :class="(item._item.ativo == 0 ? 'ed-inativo' : '')+(item.class ? ' '+item.class : '')"
            :style="(item.style ? item.style : '')"
            :title="(item._item.ativo == 0 ? 'Registro inativo' : '')+(item.title ? item.title : '')"
            :key="indexHeader+1"
            v-html="item[header.value]"
          ></span>

          <span class="ed-table-info" :key="indexHeader+2">
            <label v-if="item._item.id && indexHeader == 0 && header.show_id" :key="indexHeader+3">
              <b>CÓDIGO:</b> {{$utilidade.formataCampo(item._item.id,6)}}
            </label>

            <label v-if="item._item.contato_documento && indexHeader == 0" :key="indexHeader+4">
              <b>DOCUMENTO:</b> {{$utilidade.mascara(item._item.contato_documento)}}
            </label>

            <label v-if="item._item.contato_email && indexHeader == 0" :key="indexHeader+5">
              <b>EMAIL:</b> {{item._item.contato_email}}
            </label>

            <label v-if="item._item.parent_contato_nome && item._item.contato_nome && item._item.contato_nome != item._item.parent_contato_nome && indexHeader == 0" :key="indexHeader+6">
              <b>EMPRESA:</b> {{item._item.parent_contato_nome}}
            </label>

            <label v-if="item._item.contato_grupo_nome && indexHeader == 0 && ($root.$session.getUsuarioLogado && ($root.$session.getUsuarioLogado.tipo_usuario.id == 3 || $root.$session.getUsuarioLogado.tipo_usuario.id == 4 || $root.$session.getUsuarioLogado.tipo_usuario.id == 2))" :key="indexHeader+6">
              <b>GRUPO:</b> {{item._item.contato_grupo_nome}}
            </label>
          </span>

        </template>
      </v-data-table>

      <ed-pagination v-if="pagination && !loading" :pagination="pagination" @page="onBusca" />
    </div>
  </div>
</template>
</template>
</v-data-table>
</v-card>
</div>
</template>
</v-data-table>
</v-card>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import { EdButton, EdInputText, EdPagination, EdAlert } from "template";

export default {
  name: "EdTable",
  components: {
    EdButton,
    EdInputText,
    EdPagination,
    EdAlert,
  },
  props: {
    headers: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    rows: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    pagination: {
      type: Object,
      required: false,
      default: function () {
        return null;
      },
    },
    config:{
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },  
    loading: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledSelectedRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledAcoesRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledEditRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledDeleteRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledRegisterRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledSearchRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
    disabledUpdatedRows: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },
  },
  beforeDestroy() {
    this.selected = [];
    this.tableHeaders = [];
    this.tableRows = [];
    this.busca = {
      search: null,
      orderBy: null,
      orderDesc: null,
      page: 1,
    };
  },
  data() {
    return {
      selected: [],
      tableHeaders: [],
      tableRows: [],
      options: null,
      busca: {
        search: null,
        page: 1,
      },
      drawer: false,
    };
  },
  created() {},
  mounted() {
    this.inicialize();
  },
  computed: {
    ...mapGetters("common", ["getResponse"]),
    getConfig(){
      return Object.assign(
        {
          registerName:'Novo Registro',
          registerIcon:this.$utilidade.getIcone('cadastrar'),
          searchPlaceholder: 'Digite aqui sua pesquisa',
          noDataFound:'Nenhum registro encontrado'
        },
      this.config)
    }
  },
  methods: {
    inicialize() {
      this.$utilidade.console("::EdTable template loaded::");

      this.tableHeaders = [];
      this.tableRows = [];

      this.headers.forEach((header) => {
        this.tableHeaders.push(header);
      });

      this.rows.forEach((row) => {
        this.tableRows.push(row);
      });

      if (!this.disabledAcoesRows) {
        this.tableHeaders.push({
          value: "acoes",
          class: "ed-table-acoes",
          width: "180px",
          sortable: false,
          text: "",
        });
      }
    },

    onBusca(page = {}) {
      this.$emit("search", Object.assign(this.busca, page));
    },
  },
  watch: {
    headers: {
      handler: function (newVal) {},
      deep: true,
    },
    rows: {
      handler: function (newVal) {
        this.inicialize();
      },
      deep: true,
    },
    pagination: {
      handler: function (newVal) {},
      deep: true,
    },
    selected() {
      this.drawer = this.selected.length > 0;
    },
    options() {
      if (
        this.options &&
        this.options.sortBy.length > 0 &&
        this.options.sortDesc.length > 0
      ) {
        this.busca.orderBy = this.options.sortBy[0];
        this.busca.orderDesc = this.options.sortDesc[0];
        this.onBusca();
      }
    },
    loading() {},
    config(){},
    disabledSelectedRows() {},
    disabledAcoesRows() {},
    disabledEditRows() {},
    disabledDeleteRows() {},
    disabledSearchRows() {},
    disabledRegisterRows() {},
  },
};
</script>

<style>
.ed-table tr th {
  font-size: 13px !important;
  text-transform: uppercase;
  font-weight: bold;
}

.ed-table tr td {
  font-size: 13px !important;
}

.ed-table-acoes {
  text-align: center;
  width: 180px;
}

@media only screen and (max-width: 800px) {
  .ed-table-acoes {
    text-align: center;
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/template/EdTable.vue